// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".clsStatus[data-v-3564fae3] {\n  font-size: 0.12rem;\n  color: #000000;\n}\n", ""]);
// Exports
module.exports = exports;
